import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Button } from '@lt/components';
import ClearFilterIcon from '@lt/components/icons-react/rebrand/Refresh';

interface IFiltersClearButton {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  isMobile?: boolean;
  className?: string;
}

/**
 * Кнопка сброса фильтров
 */
const FiltersClearButton: FC<IFiltersClearButton> = ({
  onClick,
  className,
  isMobile = false,
}) => {
  const { t } = useTranslation();
  return (
    <ClearButton
      className={className}
      functional={isMobile}
      size="flex"
      onClick={onClick}
      isMobile={isMobile}
      offHover
    >
      <Icon />
      {isMobile
        ? t('filters.clearbutton.mobile')
        : t('filters.clearbutton.desktop')}
    </ClearButton>
  );
};

const ClearButton = styled(Button)`
  width: inherit;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const Icon = styled(ClearFilterIcon)`
  height: 12px;
`;

const FiltersClearButtonStyles = {
  ClearButton,
  Icon,
};

export { FiltersClearButton, FiltersClearButtonStyles };
